import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Fab from '@mui/material/Fab';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { closeUserProjectWindow } from '../../redux/actions/controlbuttonaction'
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { sidebarwith } from './const';
import { bgColors } from '../utils/bgColor';
import { useDispatch } from 'react-redux';
import {Landuse,Croplist, Season, CapacityType, CropGroup} from '../FormComopents/Form/Const'
import ComboBox from '../FormComopents/Form/ComboBox';
import TextfieldNumber from '../FormComopents/Form/TextfieldNumber'
import CustomTextField from '../FormComopents/Form/CustomTextField'
import TextField from '@mui/material/TextField';

import { useSelector } from 'react-redux';
import { BootstrapDialog} from '../FormComopents/Form/CustomDialog';
import DatePicker from '../FormComopents/Form/DatePicker'
import PostUserproject from '../api_servcies/PostUserproject';
const drawerWidth = sidebarwith;
const UserProjectWindow=(Props) =>{
  const {openUserProjectWindow} = Props
  const selectedfeature = useSelector(state => state.mapreducer.selectedfeature)
  const [feature , setFeature] =useState(selectedfeature)
  useEffect(()=> {
    setFeature(selectedfeature)
  },[selectedfeature])

  const [commitPoly, setCommitPoly] = useState({
    loading:false,
    commitstate: '',
    error:''

  })
  const dispatch = useDispatch()
  const [formState, setFormState] = useState({
    name:'',
    landuse: '',
    energy: false,
    capacitytype: '',
    capacity: 0,
    group_name: '',
    crop: '',
    season: '',
    from_date: 'infinity',
    to_date:'infinity',
    comment:''
  })


  const onLanduseChange = (e, value) => {
    let _selectedoption = value.label
      setFormState({
        ...formState,
        landuse: _selectedoption,
        energy: false
        
      }) 
    if (_selectedoption === 'Re-generation') {
      setFormState({
         ...formState,
        landuse: _selectedoption,
        energy: true
        
      })
    }
    else if (_selectedoption !== 'Re-generation') {
      setFormState({
          ...formState,
        landuse: _selectedoption,
        energy: false
      })
    }
    else {
      setFormState({
        landuse: _selectedoption,
        energy: false      
      })
    }

     
  }

  const onCropChange = (e,value) => {
    let _selectedoption = value.label
      setFormState({
        ...formState,
        crop:_selectedoption
      })
  }

  const onSeasonChange = (e,value) => {
    let _selectedoption = value.label
      setFormState({
        ...formState,
        seasons:_selectedoption
      })
  }

  const onChangeGroupName = (e,value) => {
    let _selectedoption = value.label
      setFormState({
        ...formState,
        Group_name:_selectedoption
      })
  }

  const onCapacityChange = (event) => {
    setFormState({
      ...formState,
      capacity: event.target.value,
    });
  };

  const onNameChange = (event) => {
    setFormState({
      ...formState,
      name: event.target.value,
    });
  };

  const onCommentChange = (event) => {
    setFormState({
      ...formState,
      comment: event.target.value,
    });
  };
  
  const onCapacityTypeChange = (e,value) => {
    setFormState({
      ...formState,
      capacitytype: value.label,
    });
  };
const user_data = JSON.parse(sessionStorage.getItem("user"))
  const handleSubmit = (e) => {
    e.preventDefault();
    let geom_cord = []
    if(selectedfeature===undefined || selectedfeature.coords.length <=0)
    {
      alert('no geom to commit')
    }
    else{
        geom_cord = feature.coords
        // const currentdatetime = new Date().toISOString()
        // console.log(currentdatetime)
        const all_Form_data = {
        feature_id: feature.id,
        feature_cord: geom_cord,
        feature_name:formState.name,
        user_name: user_data.user_name,
        email_id:user_data.email_id,
        group_name:formState.group_name,
        landuse: formState.landuse,
        crop: formState.crop,
        season: formState.season,
        capacitytype: formState.capacitytype,
        capacity: formState.capacity,
        comment: formState.comment,
        from_date: formState.from_date,
        to_date: formState.to_date,
        name: formState.name
      }
      try {
        setCommitPoly({...commitPoly, 
        loading:true})
        PostUserproject(all_Form_data)
      } 
      catch (error) { 
        setCommitPoly({...commitPoly,
          loading:false,
          error: error
        })
      }
    }
  }
return (
<BootstrapDialog
    onClose={() => dispatch(closeUserProjectWindow)}
    aria-labelledby="customized-dialog-title"
    open={openUserProjectWindow}
    scroll="paper"
    sx={{
        "& .MuiDialog-container": {
           alignItems: "flex-start",
           "& .MuiPaper-root": {
                  width: "100%",
                  minHeight:"200px",
                  marginTop:'0.25rem',
                  marginLeft:'0.5rem',
                  maxWidth: drawerWidth  // Set your width here
              
                },
        },
     }}
    
    PaperProps={{sx: 
      {position:'fixed' ,
      //  marginLeft:'0.5rem', 
       top:0, left:0} ,
       style:{borderRadius: 10,
       background:bgColors.default_backgroun_grey
    // background:bgColors.grey_400
    }}}
    >
      {/* <DialogContent dividers></DialogContent> */}
      <DialogContent dividers>
   
      <Grid container 
          // style = {{marginBottom:'3%',marginTop:'3%' }}
          >
        <Grid item xs={11} container justifyContent="left">
        <Typography   
          style={{color:bgColors.font_blue, 
          fontSize: 30, 
          fontFamily: 'roboto'}}>
         User-project
        </Typography>
        </Grid>
        <Grid item xs={1} container justifyContent="flex-end">
        <IconButton onClick={() => dispatch(closeUserProjectWindow)}>
        <CloseSharpIcon fontSize='medium' 
         style={{color:bgColors.font_blue}}/>
        </IconButton>
        </Grid>
      </Grid>
      <Divider style={{color:bgColors.grey_500}}/>

      <Grid container spacing={1}  justifyContent="center">
      <Grid item sx={{marginTop:'0.5rem', width:'306px'}}>
      <TextField
        fullWidth
        size="small"
        label = "Name"
        id="name"
        onChange= {onNameChange}
        sx={{ background: `${bgColors['gm2-grey-2=300']} !important`
          }}
      />
     </Grid>
      <Grid item >
      <ComboBox
        disablePortal
        label="landuse"
        options={Landuse}
        onChange={onLanduseChange} 

      />
      </Grid>
      { formState.energy &&
      <Grid item >
        <ComboBox
        disablePortal
        label="CapacityType"
        options={CapacityType}
        onChange={onCapacityTypeChange} 
      /> 
        </Grid>
      }
   
  
      { formState.energy &&
      <Grid item >
      <TextfieldNumber
        disablePortal
        label={"Capacity"}
        unit={"KW"}
        id={"capacity-input-field"}
        onChange={onCapacityChange} 
      />  
       </Grid>
    } 

{formState.landuse==='Agriculture' &&
      <Grid item >
        <ComboBox
        disablePortal
        id='CropGroup'     
        label="CropGroup"
        options={CropGroup}
        onChange={onChangeGroupName} 
      />
      </Grid>

   }

{formState.landuse==='Agriculture' &&
      <Grid item >
        <ComboBox
        disablePortal
        id='Season'        
        label="Season"
        options={Season}
        onChange={onSeasonChange} 
      />
      </Grid>

   }

  {formState.landuse==='Agriculture' &&
        <Grid item >
        <ComboBox
        disablePortal
        id='Crop'        
        label="Crop"
        options={Croplist}
        onChange={onCropChange} 
      />
      </Grid>
   }
     {formState.landuse==='Agriculture' &&
      <Grid item >
       <DatePicker 
       label= "From date"
       value = {formState.from_date}
       onChange={(newValue) => {
        setFormState({...formState,from_date:newValue.$d});
      }}
      //  onChange = {onChangefromDate}
       />  
       </Grid>
  }

    {formState.landuse==='Agriculture' &&
          <Grid item>
          <DatePicker 
          padding={'5rem'}
          label= "To date"
          value = {formState.to_date}
          onChange={(newValue) => {
            setFormState({...formState,to_date:newValue.$d
            });
          }}
          />  
          </Grid>
      }
      <Grid item >
      <CustomTextField
        label = "Comment"
        id="comment"
        onChange= {onCommentChange}
        multiline
        rows={4}
      />
     </Grid>
    </Grid>
   <Grid container justifyContent="flex-end" padding={1} >
    <Fab variant="extended" 
        // size="small"
        style={{
          right:'2rem',
          color: bgColors.font_blue, 
          background:bgColors.default_background,
          opacity: '0.9',
          alignItems: 'center',
          width:'60%',
        }}
        onClick={handleSubmit}
        // // onClick = {handleOpen()}
        //   onClick={() => setOpen(true)}
        >
        <AddCircleIcon  style={{ marginRight:'0.25rem' }}
       
        />
        add to folio
      </Fab>
      </Grid>
      </DialogContent>
    </BootstrapDialog>
  //  </Box>
  );
}
export default UserProjectWindow
